import React, { Component } from 'react'
import Responsive from '../../../components/Responsive';
import moment from 'moment';
import HttpServices from '../../../utils/Http.services';
import { msToHMS, checkTranslation, translate } from "../../../utils/useful";
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { bindActionCreators } from 'redux';
import { color } from 'd3';

class StartQuiz extends Component {

    state = {}
    startTimer = false
    componentDidMount() {
        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.backToQuizPage('start')

            })
        }
        if (this.props.current) {
            this.init()
        }
        this.props.changeBackbtn('true')
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log('this.props?.current1', this.props.quiz)
        // console.log('this.props?.current2', this.props.current)
        if (this.props.current && (JSON.stringify(this.props.current) != JSON.stringify(prevProps.current)) && !this.startTimer) {
            this.init()
        } else if (prevState.startTimer != this.startTimer && this.startTimer == false && this.props.current) {
            this.init()
        }
    }

    init() {
        this.startTimer = true
        console.log('initSTARTQUIZ')
        // let seconds = this.props.quiz?.values.duration
        console.log('this.props.quiz?.values?.duration', this.props.quiz?.values)
        if (this.props.quiz?.values?.duration?.length > 0) {
            let duration = this.props.quiz?.values?.duration
            let time = String((Number(duration[0]) * 3600) + (Number(duration[1]) * 60) + (Number(duration[2]) * 1))
            let seconds = time
            if (this.props.current) {
                console.log('this.props.current.startTime', moment(this.props.current.startTime))
                const startTime = moment(this.props.current.startTime);
                const nowTime = moment(new Date());
                let diff = nowTime.diff(startTime)
                seconds = time - (diff / 1000)
            }
            let init = true
            this.setState({ timer: seconds }, () => {
                this.interval = setInterval(() => {
                    let timer = this.state.timer - 1
                    if (timer < 0) {
                        if (!init) {
                            this.props.endInquiry()
                            clearInterval(this.interval)
                        }
                    } else {
                        this.setState({ timer }, () => { })
                        init = false
                    }
                }, 1000)
            });
        }
        else {
            this.startTimer = false
        }
    }

    // time = () => {
    //     const startTime = moment(this.props.current.startTime);
    //     const nowTime = moment(new Date());
    //     let diff = nowTime.diff(startTime)
    //     let seconds = (this.props.inquiry.time * 60) - (diff / 1000)
    //     if (seconds > 0) {
    //         this.setState({ timer: seconds })
    //     } else {
    //         // alert("time is over")
    //         setTimeout(() => {
    //             this.props.endInquiry()
    //             clearInterval(this.interval)
    //         }, 200)
    //     }
    //     // const days = parseInt((nowTime - startTime) / (1000 * 60 * 60 * 24));
    //     // const hours = parseInt(Math.abs(nowTime - startTime) / (1000 * 60 * 60) % 24);
    //     // const minutes = parseInt(Math.abs(nowTime.getTime() - startTime.getTime()) / (1000 * 60) % 60);
    //     // const passedSeconds = parseInt(Math.abs(nowTime.getTime() - startTime.getTime()) / (1000) % 60); 
    //     // this.setState({ passedSeconds })
    // }

    startInquiry = () => {
        // let body: {}
        // if(this.props.current){
        //     body= this.props.current.inquiry._id
        // }else{
        //     body= this.props.inquiry?._id
        // }
        let startDate = moment(this.props.quiz?.values?.date).valueOf()
        let expiryDate = moment(this.props.quiz?.values?.expiryDate).valueOf()
        let nowDate = moment().valueOf()
        if ((startDate <= nowDate && expiryDate >= nowDate) || this.props.quiz?.creator == this.props.user?.info?._id) {
            this.setState({ isLoading: true })
            console.log('this.props.quiz', this.props.quiz)
            HttpServices.request('startInquiry', { inquiry: this.props.quiz?._id, applet: this.props.applet._id ?? this.props.applet }, ((fetchResult, fetchError) => {
                this.setState({ isLoading: false })
                if (fetchError) {
                    // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                this.props.startQuiz()
                // this.props.changeStage('quiz')
            }))
        }
        else {
            alert('Time error!!')
        }

    }

    continueInquiry = () => {
        this.props.changeStage('quiz')
    }

    changeQuizPage = () => {
        this.props.changeQuizPage([])
        this.props.changeStage('start')
    }

    getTeacherName = (teacher) => {
        if (this.props.quiz.populates.users) {
            let userInfo
            this.props.quiz.populates.users.map((element) => {
                if (element._id == teacher) {
                    userInfo = element.fullname
                }
            })
            return userInfo
        }
    }

    render() {
        let quiz = this.props.quiz
        let now = moment().valueOf()
        return (
            <div className=" w-100 scroll-no-scrollbar h-100 " style={{}}>
                <div className='w-100 p-4'>
                    <Responsive width={this.props.width} media={{ sm: '12' }}>
                        <div className=' w-100 d-flex flex-column'>
                            <div className=' pt-1'>
                                <div className='w-100  br-10 flexc bg-white '>
                                    <div className="flexcc">
                                        <img className="flexcc" src='/assets/icons/inquiry-name2.png' style={{ width: 70, height: 70, }} />
                                    </div>

                                    <div className='mld-3'>
                                        <p className='text-semibig text-semibold'>{translate("Inquery Participation")}</p>
                                        <p className='text-smaller color-gray-2'>{translate('To start your participation, Click the "Start Inquery" button.')}</p>

                                    </div>

                                </div>


                                <div className=' w-100 mt-3 mb-4'>
                                    <div className='w-100 bg-white shadow-2 br-10 px-4 pt-4'>


                                        <div className=''>
                                            <p className="font-size-18  weight-500" >{checkTranslation(quiz?.values?.title)}</p>
                                            <p className="font-size-13  mt-2" style={{ whiteSpace: 'break-spaces' }} >{checkTranslation(quiz?.values?.description)}{checkTranslation(quiz?.values?.description1)}</p>
                                        </div>

                                        <div className='flexcb flex-wrap mt-4'>

                                            {quiz?.values?.teacher &&
                                                <Responsive width={this.props.width} media={{ sm: '6' }}>
                                                    <div className='flexc pb-4' style={{}}>
                                                        <p className='weight-500 font-size-14' style={{ width: '130px' }}>{translate('Creator')} :</p>
                                                        {console.log('quiz?.values', quiz?.values)}
                                                        <p className='font-size-13'>{this.getTeacherName(quiz?.values?.teacher)}</p>
                                                    </div>
                                                </Responsive>
                                            }
                                            <Responsive width={this.props.width} media={{ sm: '6' }}>
                                                <div className='flexc pb-4' style={{}}>
                                                    <p className='weight-500 font-size-14' style={{ width: '130px' }}>{translate('Questions')} :</p>
                                                    <p className='font-size-13'>{checkTranslation(quiz?.values?.questions?.length)}</p>
                                                </div>
                                            </Responsive>
                                            {quiz?.values?.duration?.length > 0 &&
                                                <Responsive width={this.props.width} media={{ sm: '6' }}>
                                                    <div className='flexc pb-4' style={{}}>
                                                        <p className='weight-500 font-size-14' style={{ width: '130px' }}>{translate('Duration')} :</p>
                                                        <p className='font-size-13'>{((quiz?.values?.duration[0] ?? '00') + ':' + (quiz?.values?.duration[1] ?? '00') + ':' + (quiz?.values?.duration[2] ?? '00'))}</p>
                                                    </div>
                                                </Responsive>
                                            }
                                            <Responsive width={this.props.width} media={{ sm: '6' }}>
                                                <div className='flexc pb-4' style={{}}>
                                                    <p className='weight-500 font-size-14' style={{ width: '130px' }}>{translate('Opening Time')} :</p>
                                                    <p className='font-size-13'>{moment(quiz?.values?.date).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                                </div>
                                            </Responsive>
                                            {quiz?.values?.expiryDate &&
                                                <Responsive width={this.props.width} media={{ sm: '6' }}>
                                                    <div className='flexc pb-4' style={{}}>
                                                        <p className='weight-500 font-size-14' style={{ width: '130px' }}>{translate('Closing Time')} :</p>
                                                        <p className='font-size-13'>{moment(quiz?.values?.expiryDate).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                                    </div>
                                                    {(this.props?.current && this.props.current.finishTime) && (
                                                        <div className='flexc pb-4' style={{}}>
                                                            <p className='weight-500 font-size-14' style={{ width: '130px' }}>{translate('Your previous result is')} : </p>
                                                            <p className='color-gray-3 weight-200'> {(((this.props.current?.score)))}</p>
                                                        </div>
                                                    )}
                                                </Responsive>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Responsive>
                    <div className='scroll-no-scrollbar' style={{}}>
                        <Responsive width={this.props.width} media={{ xs: "12" }}>
                            <div className=' w-100 d-flex window-content-radius' style={{}}>
                                <div className='' style={{ borderRadius: 8, flex: 1 }}>
                                    {(!this.props?.current && this.props.allQuizes?.length == 0 && (this.props.quiz?.values?.date <= now && (!this.props.quiz?.values?.expiryDate || this.props.quiz?.values?.expiryDate >= now))) && (
                                        <div className='' style={{}}>
                                            <ButtonAnimated
                                                icon={'/assets/icons/arrow-right-white.svg'}
                                                bg={this.props.colors.background ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'}
                                                title={translate('Start Inquiry')}
                                                textColor={this.props.colors.textColor ? this.props.colors.textColor : '#fff'}
                                                onClick={() => this.startInquiry()}
                                            />
                                        </div>
                                    )}
                                    {(this.props?.current && !this.props.current.finishTime) && (
                                        <div className=''>
                                            <ButtonAnimated
                                                icon={'/assets/icons/arrow-right-white.svg'}
                                                bg={this.props.colors.background ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'}
                                                title={translate('Continue Inquiry')}
                                                textColor={this.props.colors.textColor ? this.props.colors.textColor : '#fff'}
                                                onClick={() => this.continueInquiry()}
                                            />
                                            {this.state.timer ?
                                                (this.state.timer >= 0 ? (
                                                    <div className='flexcb py-4'>
                                                        <p className='weight-500'>{translate('Remaining time')}</p>
                                                        <p className='weight-200 red-box-fs px-2 py-1 br-5'>{msToHMS(this.state.timer)}</p>
                                                    </div>
                                                ) : (
                                                    <div className='flexcb py-4'>
                                                        <p className='weight-500'>{translate('Remaining time')}</p>
                                                        <p className='weight-200 red-box-fs px-2 py-1 br-5'>{translate("Time is over")}</p>
                                                    </div>
                                                )) : (
                                                    <div></div>
                                                )}
                                        </div>
                                    )}


                                    {this.props.allQuizes?.length != 0 && !this.props.current && (this.props.quiz?.values.date <= now && (!this.props.quiz?.values?.expiryDate || this.props.quiz?.values?.expiryDate >= now)) && (
                                        <>
                                            {Array.isArray(this.props.allQuizes) && this.props.allQuizes[0]?.values?.score? (
                                                <div className='row m-0'>
                                                    <p className='mrd-2' style={{ color: '#909090', fontSize: 14, fontWeight: 600 }}>
                                                        {translate('Your last mark for this exam was')}  
                                                    </p>
                                                    <p style={{ fontSize: 16, fontWeight: 600 }}>
                                                    {this.props.allQuizes[0].values.score} 
                                                    </p>
                                                </div>
                                            ) : (
                                                <p style={{ color: '#909090', fontSize: 14, fontWeight: 600 }}>
                                                    {translate('Your previous mark is not ready yet')}
                                                </p>

                                            )}
                                            {(this.props.allQuizes?.length > 0 && this.props.quiz?.values?.retakeNumber > 0 && this.props.allQuizes?.length< this.props.quiz?.values?.retakeNumber  && !this.props.allQuizes[0].values.cantRetake ) ? (

                                                <div className=''>
                                                    <ButtonAnimated
                                                        icon={'/assets/icons/arrow-right-white.svg'}
                                                        bg={this.props.colors.background ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'}
                                                        title={translate('Start Inquiry Again')}
                                                        textColor={this.props.colors.textColor ? this.props.colors.textColor : '#fff'}
                                                        onClick={() => this.startInquiry()}
                                                    />
                                                </div>
                                            ) : (
                                                <p style={{ color: '#ee5050', fontWeight: 600 }}>
                                                    {translate('You are not able to retake this exam')}
                                                </p>
                                            )}
                                        </>
                                    )}
                                    {this.props.quiz?.values?.date > now &&(
                                                <p style={{ color: '#ee5050', fontWeight: 600 }}>
                                                    {translate("This quiz haven't started yet")}
                                                </p>

                                    )}
                                    {this.props.quiz?.values?.expiryDate && this.props.quiz?.values?.expiryDate < now &&(
                                                <p style={{ color: '#ee5050', fontWeight: 600 }}>
                                                    {translate("This quiz has been expired")}
                                                </p>

                                    )}
                                </div>
                            </div>
                        </Responsive>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StartQuiz);
